import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { BillingPlanTier } from '@core/products-types';

@Pipe({
  name: 'rtPlanPickerProductDescription',
  standalone: true,
})
export class PlanPickerProductDescriptionPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}
  public transform(codename: BillingPlanTier): string | void {
    // eslint-disable-next-line default-case
    switch (codename) {
      case BillingPlanTier.Launch:
        return this.i18n.translate('app.pricing.plan_picker.launch_desc');
      case BillingPlanTier.Scale:
        return this.i18n.translate('app.pricing.plan_picker.scale_desc');
      case BillingPlanTier.Lead:
        return this.i18n.translate('app.pricing.plan_picker.lead_desc');
      case BillingPlanTier.Start:
        return this.i18n.translate('app.pricing.plan_picker.launch_desc');
      case BillingPlanTier.Grow:
        return this.i18n.translate('app.pricing.plan_picker.scale_desc');
      case BillingPlanTier.Optimize:
        return this.i18n.translate('app.pricing.plan_picker.lead_desc');
    }
  }
}
